import { render } from "./GetPaymentPopup.vue?vue&type=template&id=87b75c5c&scoped=true"
import script from "./GetPaymentPopup.vue?vue&type=script&lang=js"
export * from "./GetPaymentPopup.vue?vue&type=script&lang=js"

import "./GetPaymentPopup.vue?vue&type=style&index=0&id=87b75c5c&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b75c5c"]])

export default __exports__